export const MIN_REASON_LENGTH = 15;
export const MAX_REASON_LENGTH = 500;

export const LOCK_EXPIRY_DAYS = 14;

export const TOOLTIP_TEXTS = {
  lock: "Lock this professional's account",
  unlock: "Unlock this professional's account",
  lockedByOther: "This professional is locked by another workplace",
} as const;
